module.exports = __webpack_public_path__ + "lazer5.png?8e12432d4f178fe13a8a4627cb3045b5";